import jQuery from 'jquery';

;(function($){

var noDataStr = '-';
//var DATA_URL = 'http://www.xj-storage.jp/public-xbrl/Data.aspx';

var DATA_URL = (("https:" == document.location.protocol) ? "https://" : "http://") + 'www.xj-storage.jp/public-xbrl/Data.aspx';

function getXJ_Table(id, company, chartType, number, lang, forceUnit, minusFormat, showTitle, onlyEndOfYear) {

  if (!(id && id.length > 0)
   || !(company && company.length > 0)
   || !(chartType && chartType.length > 0)
   || !(number && number.length > 0)
   || !(lang && lang.length > 0)) {
    alert('error!');
    return;
  }

  var url = getDataURL(company, chartType, number, lang);

  $.getJSON(url, function(data) {
    $('#' + id).empty();
    var x = '';
    var ylen = 5;
    var years = new Array();

    $.each(data.fiscalDate, function(i,item) {
      years.push(item);
    });

    years = years.sort();
    while (years.length > ylen) {
      years.shift();
    }

    $.each(data.item, function(i,item) {
      if (item.fiscal) {
      var unit = forceUnit;
      if (unit == undefined) {
        unit = item.unit;
      }

      if (!showTitle) {
        x += '<div class="xj_chart_table_caption">';
        x += '<span class="xj_chart_table_caption_title">';
        x += item.label;
        x += '</span>';
        x += '<span class="xj_chart_table_caption_unit">';
        x += '（';
        x += getConsolidate(item.consolidate, lang);
        x += ', ';
        x += getUnit(item.unitFormula, unit, lang);
        x += '）';
        x += '</span>';
        x += '</div>';
      }

      x += '<div class="xj_chart_table_wrap">';
      x += '<table class="xj_chart_table">';
      x += '<tr>';
      if (showTitle || !onlyEndOfYear) {
        x += '<td';
        if(showTitle && !onlyEndOfYear){
          x += ' colspan="2"';
        }
        x += ' class="xj_chart_header_first">&nbsp;</td>';
      }

      for (var i = 0; i < years.length; i++) {
        var tdLastClassName = getTdLastClassName(i+1 == years.length);
        x += '<td class="xj_chart_header' + tdLastClassName + '">';
        x += years[i].substring(0, 7);
        if (i == years.length-1 && onlyEndOfYear) {
          $.each(item.fiscal, function(j,fiscal) {
            //if (item.fiscal.length-ylen-1 < j) {
            if (years[i] + ' 00:00:00' == fiscal.end + ' 00:00:00') {
              /*var q = fiscal.record[fiscal.record.length-1].q;
              var maxlen = getMaxLength(item);
              if (maxlen != q) {*/
              if (fiscal.record[fiscal.record.length-1].endOfYear != 'true') {
                x += '（';
                x += fiscal.record[fiscal.record.length-1].q;
                x += 'Q）';
              }
            }
          });
        }
        x += '</td>';
      }
      x += '</tr>';

      if (onlyEndOfYear) {
        x += getEOYContents(ylen, item, unit, minusFormat, showTitle, years, lang);
      } else {
        x += getQContents(ylen, item, unit, minusFormat, showTitle, years, lang);
      }
      x += '</table>';
      x += '</div>';
      }
    });
    $('#' + id).html(x);
  });
}

function getEOYContents(ylen, item, unit, minusFormat, showTitle, years, lang) {
  var x = '';
  x += '<tr>';
  if (showTitle) {
    x += '<td class="xj_chart_title">';
    x += item.label;
    x += '<span class="xj_chart_unit">（';
    x += getConsolidate(item.consolidate, lang);
    x += ', ';
    x += getUnit(item.unitFormula, unit, lang);
    x += '）</span>';
    x += '</td>';
    //x += '<td class="xj_chart_q_last">';
    //x += 'EOY';
    //x += '</td>';
  }
  for (var i = 0; i < years.length; i++) {
    var added = false;
    $.each(item.fiscal, function(j,fiscal) {
      if (years[i] == fiscal.end) {
        added = true;
        var cval= '';
        $.each(fiscal.record, function(k,record) {
          if (fiscal.end + ' 00:00:00' == years[years.length-1] + ' 00:00:00') {
            if (fiscal.record.length == k+1) {
              cval = getValue(record.value, unit, item.unitFormula, minusFormat);
            }
          } else {
            if (record.endOfYear == 'true') {
              cval = getValue(record.value, unit, item.unitFormula, minusFormat);
            }
          }
        });
        cval = checkCval(cval);
        var noValClass = getNoValClassName(cval);
        var tdLastClassName = getTdLastClassName(i == years.length-1);
        x += '<td class="xj_chart_value_last' + tdLastClassName + noValClass + '">';
        x += cval;
        x += '</td>';
      }
    });
    if (!added) {
      var tdLastClassName = getTdLastClassName(i == years.length-1);
      x += '<td class="xj_chart_value_last' + tdLastClassName + ' xj_chart_no_value">';
      x += noDataStr;
      x += '</td>';
    }
  }

  x += '</tr>';
  return x;
}

function getQContents(ylen, item, unit, minusFormat, showTitle, years, lang) {
  var x = '';
  var maxlen = getMaxLength(item);
  for (var i = 0; i < maxlen; i++) {
    x += '<tr>';
    if (showTitle && i == 0) {
      x += '<td';
      x += ' rowspan="';
      x += maxlen;
      x += '"';
      x += ' class="xj_chart_title">';
      x += item.label;
      x += '<span class="xj_chart_unit">（';
      x += getConsolidate(item.consolidate, lang);
      x += ', ';
      x += getUnit(item.unitFormula, unit, lang);
      x += '）</span>';
      x += '</td>';
    }
    if (i+1 == maxlen) {
      x += '<td class="xj_chart_q_last">';
    } else {
      x += '<td class="xj_chart_q">';
    }
    //if (i+1 == maxlen) {
    //  x += 'EOY';
    //} else {
      x += i+1;
      x += 'Q';
    //}
    x += '</td>';
    for (var s = 0; s < years.length; s++) {
      var added = false;
      $.each(item.fiscal, function(j,fiscal) {
        if (years[s] == fiscal.end) {
          added = true;
          var cval= '';
          $.each(fiscal.record, function(k,record) {
            if (i+1 == record.q) {
              cval = getValue(record.value, unit, item.unitFormula, minusFormat);
            }
          });
          cval = checkCval(cval);
          var noValClass = getNoValClassName(cval);
          var tdLastClassName = getTdLastClassName(s == years.length-1);
          if (i+1 == maxlen) {
            x += '<td class="xj_chart_value_last' + tdLastClassName + noValClass + '">';
          } else {
            x += '<td class="xj_chart_value' + tdLastClassName + noValClass + '">';
          }
          x += cval;
          x += '</td>';
        }
      });
      if (!added) {
        var tdLastClassName = getTdLastClassName(s == years.length-1);
        x += '<td class="xj_chart_value_last' + tdLastClassName + ' xj_chart_no_value">';
        x += noDataStr;
        x += '</td>';
      }
    }
    x += '</tr>';
  }
  return x;
}



function getXJ_Table_EOY(id, company, chartType, number, lang, forceUnit, minusFormat, showTitle, onlyEndOfYear) {

  if (!(id && id.length > 0)
   || !(company && company.length > 0)
   || !(chartType && chartType.length > 0)
   || !(number && number.length > 0)
   || !(lang && lang.length > 0)) {
    alert('error!');
    return;
  }

  var url = getDataURL(company, chartType, number, lang);

  $.getJSON(url, function(data) {
    $('#' + id).empty();
    var x = '';
    var ylen = 5;
    var years = new Array();

    $.each(data.fiscalDate, function(i,item) {
      years.push(item);
    });

    var lastEOY = years[years.length-1];
    var didYearsPop = false;

    $.each(data.item, function(i,item) {
      if (item.fiscal) {
      $.each(item.fiscal, function(j,fiscal) {
        $.each(fiscal.record, function(j,record) {
          if (lastEOY == fiscal.end && record.endOfYear == 'true') {
            didYearsPop = true;
          }
        });
      });
      }
    });

    if (!didYearsPop) {
      years.pop();
    }

    years = years.sort();
    while (years.length > ylen) {
      years.shift();
    }

    $.each(data.item, function(i,item) {
      if (item.fiscal) {
      var unit = forceUnit;
      if (unit == undefined) {
        unit = item.unit;
      }

      if (!showTitle) {
        x += '<div class="xj_chart_table_caption">';
        x += '<span class="xj_chart_table_caption_title">';
        x += item.label;
        x += '</span>';
        x += '<span class="xj_chart_table_caption_unit">';
        x += '（';
        x += getConsolidate(item.consolidate, lang);
        x += ', ';
        x += getUnit(item.unitFormula, unit, lang);
        x += '）';
        x += '</span>';
        x += '</div>';
      }

      x += '<div class="xj_chart_table_wrap">';
      x += '<table class="xj_chart_table">';
      x += '<tr>';
      if (showTitle || !onlyEndOfYear) {
        x += '<td';
        if (onlyEndOfYear) {
          //x += ' colspan="2"';
        } else if(showTitle && !onlyEndOfYear){
          x += ' colspan="2"';
        }
        x += ' class="xj_chart_header_first">&nbsp;</td>';
      }
      for (var i = 0; i < years.length; i++) {
        var tdLastClassName = getTdLastClassName(i+1 == years.length);
        x += '<td class="xj_chart_header' + tdLastClassName + '">';
        x += years[i].substring(0, 7);
        x += '</td>';
      }
      x += '</tr>';

      if (onlyEndOfYear) {
        x += getEOYContents_EOY(ylen, item, unit, minusFormat, showTitle, years, lang);
      } else {
        x += getQContents_EOY(ylen, item, unit, minusFormat, showTitle, years, lang);
      }

      x += '</table>';
      x += '</div>';
      }
    });

    $('#' + id).html(x);
  });
}

function getEOYContents_EOY(ylen, item, unit, minusFormat, showTitle, years, lang) {
  var x = '';
  x += '<tr>';
  if (showTitle) {
    x += '<td class="xj_chart_title">';
    x += item.label;
    x += '<span class="xj_chart_unit">（';
    x += getConsolidate(item.consolidate, lang);
    x += ', ';
    x += getUnit(item.unitFormula, unit, lang);
    x += '）</span>';
    x += '</td>';
  }

  for (var i = 0; i < years.length; i++) {
    var added = false;
    $.each(item.fiscal, function(j,fiscal) {
      if (years[i] == fiscal.end) {
        added = true;
        var cval= '';
        $.each(fiscal.record, function(k,record) {
          if (record.endOfYear == 'true') {
            cval = getValue(record.value, unit, item.unitFormula, minusFormat);
          }
        });
        cval = checkCval(cval);
        var noValClass = getNoValClassName(cval);
        var tdLastClassName = getTdLastClassName(i == years.length-1);
        x += '<td class="xj_chart_value_last' + tdLastClassName + noValClass + '">';
        x += cval;
        x += '</td>';
      }
    });
    if (!added) {
      var tdLastClassName = getTdLastClassName(i == years.length-1);
      x += '<td class="xj_chart_value_last' + tdLastClassName + ' xj_chart_no_value">';
      x += noDataStr;
      x += '</td>';
    }
  }
    x += '</tr>';
  return x;
}

function getQContents_EOY(ylen, item, unit, minusFormat, showTitle, years, lang) {
  var x = '';
  var maxlen = getMaxLength(item);
  for (var i = 0; i < maxlen; i++) {
    x += '<tr>';
    if (showTitle && i == 0) {
      x += '<td';
      x += ' rowspan="';
      x += maxlen;
      x += '"';
      x += ' class="xj_chart_title">';
      x += item.label;
      x += '<span class="xj_chart_unit">（';
      x += getConsolidate(item.consolidate, lang);
      x += ', ';
      x += getUnit(item.unitFormula, unit, lang);
      x += '）</span>';
      x += '</td>';
    }
    if (i+1 == maxlen) {
      x += '<td class="xj_chart_q_last">';
    } else {
      x += '<td class="xj_chart_q">';
    }
      x += i+1;
      x += 'Q';

    x += '</td>';

    for (var s = 0; s < years.length; s++) {
      var added = false;
      $.each(item.fiscal, function(j,fiscal) {
        if (years[s] == fiscal.end) {
          added = true;
          var cval= '';
          $.each(fiscal.record, function(k,record) {
            if (i+1 == record.q) {
              cval = getValue(record.value, unit, item.unitFormula, minusFormat);
            }
          });
          cval = checkCval(cval);
          var noValClass = getNoValClassName(cval);
          var tdLastClassName = getTdLastClassName(s == years.length-1);
          if (i+1 == maxlen) {
            x += '<td class="xj_chart_value_last' + tdLastClassName + noValClass + '">';
          } else {
            x += '<td class="xj_chart_value' + tdLastClassName + noValClass + '">';
          }
          x += cval;
          x += '</td>';
        }
      });
      if (!added) {
        var tdLastClassName = getTdLastClassName(s == years.length-1);
        x += '<td class="xj_chart_value_last' + tdLastClassName + ' xj_chart_no_value">';
        x += noDataStr;
        x += '</td>';
      }
    }
    x += '</tr>';
  }
  return x;
}



//#############################################################################################
//########################################### HAITO ###########################################
//#############################################################################################

function getXJ_TableHaito(id, company, chartType, number, lang, forceUnit, minusFormat, showTitle, onlyEndOfYear) {

  if (!(id && id.length > 0)
   || !(company && company.length > 0)
   || !(chartType && chartType.length > 0)
   || !(number && number.length > 0)
   || !(lang && lang.length > 0)) {
    alert('error!');
    return;
  }

  var url = getDataURL(company, chartType, number, lang);

  $.getJSON(url, function(data) {
    $('#' + id).empty();
    var x = '';
    var ylen = 5;
    var years = new Array();

    $.each(data.fiscalDate, function(i,item) {
      years.push(item);
    });
    years = years.sort();
    while (years.length > ylen) {
      years.shift();
    }

    var checkTaxonomy = '';
    var strLabel = getTitleHaito(lang);
    var strConsolidate = '';
    var strUnit = '';

    $.each(data.item, function(i,item) {
      if (item.fiscal != null) {
        checkTaxonomy = item.taxonomy;
        strConsolidate = getConsolidate(item.consolidate, lang);
        strUnit = getUnit(item.unitFormula, item.unit, lang);
        return false;
      }
    });

    if (!showTitle) {
      x += '<div class="xj_chart_table_caption">';
      x += '<span class="xj_chart_table_caption_title">';
      x += strLabel;
      x += '</span>';
      x += '<span class="xj_chart_table_caption_unit">';
      x += '（';
      x += strConsolidate;
      x += ', ';
      x += strUnit;
      x += '）';
      x += '</span>';
      x += '</div>';
    }

    x += '<table class="xj_chart_table">';
    x += '<tr>';
    x += '<td';
    if (showTitle) {
      x += ' colspan="2"';
    }
    x += ' class="xj_chart_header_first">&nbsp;</td>';
    
    for (var i = 0; i < years.length; i++) {
      var tdLastClassName = getTdLastClassName(i+1 == years.length);
      x += '<td class="xj_chart_header' + tdLastClassName + '">';
      x += years[i].substring(0, 7);
      x += '</td>';
    }

    var maxlen = 0;

    $.each(data.item, function(i,item) {
      maxlen++;
    });

    x += '<tr>';
    if (showTitle) {
      x += '<td';
      x += ' rowspan="';
      x += maxlen;
      x += '"';
      x += ' class="xj_chart_title">';
      x += strLabel;
      x += '<span class="xj_chart_unit">（';
      x += strConsolidate;
      x += ', ';
      x += strUnit;
      x += '）</span>';
      x += '</td>';
    }

    x += getContentsHaito(data, years, ylen, 'ResultDividendPerShare1stQuarter', forceUnit, minusFormat, '1Q', maxlen)
    x += '</tr>';
    x += '<tr>';
    x += getContentsHaito(data, years, ylen, 'ResultDividendPerShare2ndQuarter', forceUnit, minusFormat, '2Q', maxlen)
    x += '</tr>';
    x += '<tr>';
    x += getContentsHaito(data, years, ylen, 'ResultDividendPerShare3rdQuarter', forceUnit, minusFormat, '3Q', maxlen)
    x += '</tr>';
    x += '<tr>';
    x += getContentsHaito(data, years, ylen, 'ResultDividendPerShareFiscalYearEnd', forceUnit, minusFormat, '4Q', maxlen)
    x += '</tr>';
    x += '<tr>';
    x += getContentsHaito(data, years, ylen, 'ResultDividendPerShareAnnual', forceUnit, minusFormat, getAnnualLabel(lang), maxlen)
    x += '</tr>';

    x += '</table>';
    x += '<br/>';

    $('#' + id).html(x);
  });
}

function getAnnualLabel(lang) {
  if (lang == 'en') {
    return 'annual';
  } else {
    return '総額';
  }
}

function getTitleHaito(lang) {
  if (lang == 'en') {
    return 'Dividend';
  } else {
    return '配当金';
  }
}

function getContentsHaito(data, years, ylen, elemName, forceUnit, minusFormat, qLabel, maxlen) {
  var unit = forceUnit;
  var x ='';
  var did = false;
  $.each(data.item, function(i,item) {
    if (item.taxonomy == elemName) {
      if (unit == undefined) {
        unit = item.unit;
      }
      if (item.fiscal != null) {
        for (var k = 0; k < ylen; k++) {
          var cval= '';
          if (k==0) {
            if (i+1 == maxlen) {
              x += '<td class="xj_chart_q_last">';
            } else {
              x += '<td class="xj_chart_q">';
            }
            x += qLabel;
            x += '</td>';
          }
          $.each(item.fiscal, function(j,fiscal) {
            if (fiscal.end == years[k]) {
              $.each(fiscal.record, function(k,record) {
                  cval = getValue(record.value, unit, item.unitFormula, minusFormat);
              });
              return false;
            }
          });
          cval = checkCval(cval);
          var noValClass = getNoValClassName(cval);
          var tdLastClassName = getTdLastClassName(k+1 == ylen);
          if (i+1 == maxlen) {
            x += '<td class="xj_chart_value_last' + tdLastClassName + noValClass + '">';
          } else {
            x += '<td class="xj_chart_value' + tdLastClassName + noValClass + '">';
          }
          x += cval;
          x += '</td>';
        }
      }else {
        if (i+1 == maxlen) {
          x += '<td class="xj_chart_q_last">';
        } else {
          x += '<td class="xj_chart_q">';
        }
        x += qLabel;
        x += '</td>';
        for (var k = 0; k < ylen; k++) {
          var tdLastClassName = getTdLastClassName(k+1 == ylen);
          if (i+1 == maxlen) {
            x += '<td class="xj_chart_value_last' + tdLastClassName + ' xj_chart_no_value">';
          } else {
            x += '<td class="xj_chart_value' + tdLastClassName + ' xj_chart_no_value">';
          }
          x += noDataStr;
          x += '</td>';
        }
      }
    }
  });
  return x;
}



//##############################################################################################
//########################################### FUKUGO ###########################################
//##############################################################################################

function getXJ_TableFukugo(id, company, chartType, number, lang, forceUnit, minusFormat, showTitle, onlyEndOfYear) {

  if (!(id && id.length > 0)
   || !(company && company.length > 0)
   || !(chartType && chartType.length > 0)
   || !(number && number.length > 0)
   || !(lang && lang.length > 0)) {
    alert('error!');
    return;
  }

  var url = getDataURL(company, chartType, number, lang);

  $.getJSON(url, function(data) {
    $('#' + id).empty();
    var x = '';
    var ylen = 5;
    var years = new Array();

    x += '<table class="xj_chart_table">';
    x += '<tr>';
    if (showTitle || !onlyEndOfYear) {
      x += '<td';
      if (onlyEndOfYear) {
        //x += ' colspan="2"';
      } else if(showTitle && !onlyEndOfYear){
        x += ' colspan="2"';
      }
      x += ' class="xj_chart_header_first">&nbsp;</td>';
    }

    var maxlen = 1;
    var lastq = 1;

    $.each(data.fiscalDate, function(i,item) {
      years.push(item);
    });

    var lastEOY = years[years.length-1];
    var didYearsPop = false;

    $.each(data.item, function(i,item) {
      if (item.fiscal) {
        $.each(item.fiscal, function(j,fiscal) {
          /*if (!hasValue(years, fiscal.end)) {
            years.push(fiscal.end);
          }*/
          var eoy = false;
          $.each(fiscal.record, function(j,record) {
            if (new Number(record.q) > maxlen) {
              maxlen = new Number(record.q);
              lastq = new Number(record.q);
            }
            if (lastEOY == fiscal.end && record.endOfYear == 'true') {
              didYearsPop = true;
            }
          });
        });
      }
    });

    if (!didYearsPop) {
      years.pop();
    }

    years = years.sort();
    while (years.length > ylen) {
      years.shift();
    }
    ylen = years.length;

    for (var i = 0; i < years.length; i++) {
      var tdLastClassName = getTdLastClassName(i+1 == years.length);
      x += '<td class="xj_chart_header' + tdLastClassName + '">';
      x += years[i].substring(0, 7);
      x += '</td>';
    }

    x += '</tr>';

    if (onlyEndOfYear) {
      maxlen = 1;
    }

    $.each(data.item, function(i,item) {

      x += '<tr>';
      if (showTitle) {
        x += '<td';
        if (maxlen > 1) {
          x += ' rowspan="';
          x += maxlen;
          x += '"';
        }
        x += ' class="xj_chart_title">';
        x += item.label;
        var unit = forceUnit;
        if (unit == undefined) {
          unit = item.unit;
        }
        x += '<span class="xj_chart_unit">（';
        x += getConsolidate(item.consolidate, lang);
        x += ', ';
        x += getUnit(item.unitFormula, unit, lang);
        x += '）</span>';
        
        x += '</td>';
      }

      for (var j = 0; j < maxlen; j++) {
        if (!onlyEndOfYear) {
          if (j == maxlen-1) {
            x += '<td class="xj_chart_q_last">';
          } else {
            x += '<td class="xj_chart_q">';
          }
          //if (j+1 == maxlen) {
          //  x += "EOY";
          //} else {
            x += j+1;
            x += 'Q';
          //}
        }
        x += '</td>';


        for (var k = 0; k < ylen; k++) {
          if (onlyEndOfYear) {
            if (k == ylen-1) {
              x += getContentsCurrentYearFukugo(item, forceUnit, minusFormat, lastq, years[k], ylen, (k == ylen-1), lastq);
            } else {
              x += getContentsFukugo(item, forceUnit, minusFormat, lastq, years[k], ylen, (k == ylen-1), lastq, onlyEndOfYear);
            }
          } else {
            x += getContentsFukugo(item, forceUnit, minusFormat, j+1, years[k], ylen, (k == ylen-1), maxlen, onlyEndOfYear);
          }
        }

        x += '</tr>';

      }

    });

    x += '</table>';
    x += '<br/>';

    $('#' + id).html(x);
  });
}


function getContentsCurrentYearFukugo(item, forceUnit, minusFormat, qLabel, cyear, ylen, last, maxlen) {
  var unit = forceUnit;
  var x ='';
  var did = false;
      if (unit == undefined) {
        unit = item.unit;
      }
      var added = false;
      var tdLastClassName = getTdLastClassName(last);
      if (item.fiscal) {
      $.each(item.fiscal, function(j,fiscal) {
        if (fiscal.end + ' 00:00:00' == cyear + ' 00:00:00') {
          var cval= '';
          $.each(fiscal.record, function(k,record) {
            if (record.endOfYear == 'true') {
              added = true;
              cval = getValue(record.value, unit, item.unitFormula, minusFormat);
            }
          });
          if (added) {
            cval = checkCval(cval);
            var noValClass = getNoValClassName(cval);
            if (last) {
              x += '<td class="xj_chart_value_last' + tdLastClassName + noValClass + '">';
            } else {
              x += '<td class="xj_chart_value' + noValClass + '">';
            }
            x += cval;
            //if (record.endOfYear != 'true') {
            //  x += '（';
            //  x += record.q
            //  x += 'Q）';
            //}
            x += '</td>';
          }
        }
      });
      }
      if (!added) {
        if (last) {
          x += '<td class="xj_chart_value_last' + tdLastClassName + ' xj_chart_no_value">';
        } else {
          x += '<td class="xj_chart_value xj_chart_no_value">';
        }
        x += noDataStr;
        x += '</td>';
      }
  return x;
}

function getContentsFukugo(item, forceUnit, minusFormat, qLabel, cyear, ylen, last, maxlen, onlyEndOfYear) {
  var unit = forceUnit;
  var x ='';
  var did = false;
      if (unit == undefined) {
        unit = item.unit;
      }
      var added = false;
      var tdLastClassName = getTdLastClassName(last);
      if (item.fiscal) {
      $.each(item.fiscal, function(j,fiscal) {
        if (fiscal.end + ' 00:00:00' == cyear + ' 00:00:00') {
          var cval= '';
          $.each(fiscal.record, function(k,record) {
            //if (qLabel == record.q) {
            if ((!onlyEndOfYear && qLabel == record.q) || (onlyEndOfYear && record.endOfYear == 'true')) {
              added = true;
              cval = getValue(record.value, unit, item.unitFormula, minusFormat);
            }
          });
          if (added) {
            cval = checkCval(cval);
            var noValClass = getNoValClassName(cval);
            if (qLabel == maxlen) {
              x += '<td class="xj_chart_value_last' + tdLastClassName + noValClass + '">';
            } else {
              x += '<td class="xj_chart_value' + tdLastClassName + noValClass + '">';
            }
            x += cval;
            x += '</td>';
          }
        }
      });
      }
      if (!added) {
        if (qLabel == maxlen) {
          x += '<td class="xj_chart_value_last' + tdLastClassName + ' xj_chart_no_value">';
        } else {
          x += '<td class="xj_chart_value' + tdLastClassName + ' xj_chart_no_value">';
        }
        x += noDataStr;
        x += '</td>';
      }
  return x;
}



//##############################################################################################
//########################################### RENTAN ###########################################
//##############################################################################################

function getXJ_TableRentan(id, company, chartType, number, lang, forceUnit, minusFormat, showTitle, onlyEndOfYear) {

  if (!(id && id.length > 0)
   || !(company && company.length > 0)
   || !(chartType && chartType.length > 0)
   || !(number && number.length > 0)
   || !(lang && lang.length > 0)) {
    alert('error!');
    return;
  }

  var url = getDataURL(company, chartType, number, lang);

  $.getJSON(url, function(data) {
    $('#' + id).empty();
    var x = '';
    var ylen = 5;
    var years = new Array();

    x += '<table class="xj_chart_table">';
    x += '<tr>';
    if (showTitle || !onlyEndOfYear) {
      x += '<td';
      if (onlyEndOfYear) {
        //x += ' colspan="2"';
      } else if(showTitle && !onlyEndOfYear){
        x += ' colspan="2"';
      }
      x += ' class="xj_chart_header_first">&nbsp;</td>';
    }

    var maxlen = 1;
    var lastq = 1;

    $.each(data.fiscalDate, function(i,item) {
      years.push(item);
    });

    var didYearsPop = false;

    $.each(data.item, function(i,item) {
      if (item.fiscal) {
        $.each(item.fiscal, function(j,fiscal) {
          var eoy = false;
          $.each(fiscal.record, function(j,record) {
            if (new Number(record.q) > maxlen) {
              maxlen = new Number(record.q);
              lastq = new Number(record.q);
            }
          });
        });
      }
    });

    years = years.sort();
    while (years.length > ylen) {
      years.shift();
    }
    ylen = years.length;
    var qValue = 0;

    for (var i = 0; i < years.length; i++) {
      var tdLastClassName = getTdLastClassName(i+1 == years.length);
      x += '<td class="xj_chart_header' + tdLastClassName + '">';
      x += years[i].substring(0, 7);
      if (i == years.length-1 && onlyEndOfYear) {
        $.each(data.item, function(n,item) {
          if (item.fiscal) {
            $.each(item.fiscal, function(j,fiscal) {
              if (years[i] + ' 00:00:00' == fiscal.end + ' 00:00:00') {
                var q = fiscal.record[fiscal.record.length-1].q;
                if (new Number(q) > qValue) {
                  qValue = q;
                }
              }
            });
          }
        });
        if (qValue != 0 && maxlen != qValue) {
          x += '（';
          x += qValue;
          x += 'Q）';
        }
      }
      x += '</td>';
    }

    x += '</tr>';

    if (onlyEndOfYear) {
      maxlen = 1;
    }

    $.each(data.item, function(i,item) {

      x += '<tr>';
      if (showTitle) {
        x += '<td';
        if (maxlen > 1) {
          x += ' rowspan="';
          x += maxlen;
          x += '"';
        }
        x += ' class="xj_chart_title">';
        x += item.label;
        var unit = forceUnit;
        if (unit == undefined) {
          unit = item.unit;
        }
        x += '<span class="xj_chart_unit">（';
        x += getConsolidate(item.consolidate, lang);
        x += ', ';
        x += getUnit(item.unitFormula, unit, lang);
        x += '）</span>';
        
        x += '</td>';
      }

      for (var j = 0; j < maxlen; j++) {
        if (!onlyEndOfYear) {
          if (j == maxlen-1) {
            x += '<td class="xj_chart_q_last">';
          } else {
            x += '<td class="xj_chart_q">';
          }
          //if (j+1 == maxlen) {
          //  x += "EOY";
          //} else {
            x += j+1;
            x += 'Q';
          //}
        }
        x += '</td>';


        for (var k = 0; k < ylen; k++) {
          if (onlyEndOfYear) {
            if (k == ylen-1) {
              x += getContentsCurrentYearRentan(item, forceUnit, minusFormat, years[k], ylen, (k == ylen-1), qValue);
            } else {
              x += getContentsFukugo(item, forceUnit, minusFormat, lastq, years[k], ylen, (k == ylen-1), lastq, onlyEndOfYear);
            }
          } else {
            x += getContentsFukugo(item, forceUnit, minusFormat, j+1, years[k], ylen, (k == ylen-1), maxlen, onlyEndOfYear);
          }
        }

        x += '</tr>';

      }

    });

    x += '</table>';
    x += '<br/>';

    $('#' + id).html(x);
  });
}


function getContentsCurrentYearRentan(item, forceUnit, minusFormat, cyear, ylen, last, qValue) {
  var unit = forceUnit;
  var x ='';
  var did = false;
      if (unit == undefined) {
        unit = item.unit;
      }
      var added = false;
      var tdLastClassName = getTdLastClassName(last);
      if (item.fiscal) {
      $.each(item.fiscal, function(j,fiscal) {
        if (fiscal.end + ' 00:00:00' == cyear + ' 00:00:00') {
          var cval= '';
          if (fiscal.record && fiscal.record[fiscal.record.length-1].q == qValue) {
            added = true;
            cval = getValue(fiscal.record[fiscal.record.length-1].value, unit, item.unitFormula, minusFormat);
          }
          if (added) {
            cval = checkCval(cval);
            var noValClass = getNoValClassName(cval);
            if (last) {
              x += '<td class="xj_chart_value_last' + tdLastClassName + noValClass + '">';
            } else {
              x += '<td class="xj_chart_value' + noValClass + '">';
            }
            x += cval;
            x += '</td>';
          }
        }
      });
      }
      if (!added) {
        if (last) {
          x += '<td class="xj_chart_value_last' + tdLastClassName + ' xj_chart_no_value">';
        } else {
          x += '<td class="xj_chart_value xj_chart_no_value">';
        }
        x += noDataStr;
        x += '</td>';
      }
  return x;
}



//##############################################################################################
//########################################### COMMON ###########################################
//##############################################################################################

function hasValue(array, val) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] + ' 00:00:00' == val + ' 00:00:00') {
      return true;
    }
  }
  return false;
}

function getMaxLength(item) {
  var maxlen = 0;
  $.each(item.fiscal, function(j,fiscal) {
    $.each(fiscal.record, function(k,record) {
      if (maxlen < record.q) {
        maxlen = record.q;
      }
    });
  });
  return maxlen;
}

function getConsolidate(consolidate, lang) {
  if (consolidate == 1) {
    if (lang == 'en') {
      return 'Consolidated';
    } else {
      return '連結';
    }
  } else {
    if (lang == 'en') {
      return 'Non Consolidated';
    } else {
      return '単体';
    }
  }
}

function getUnit(unitFormula, unit, lang) {
  var str = unitFormula;
  if (unitFormula == 'iso4217:JPY') {
    str = '';
    if (unit == '-3') {
      if (lang == 'en') {
        str += 'THOUSAND ';
      } else {
        str += '千';
      }
    } else if (unit == '-6') {
      if (lang == 'en') {
        str += 'MILLION ';
      } else {
        str += '百万';
      }
    }
    if (lang == 'en') {
      str += 'JPY';
    } else {
      str += '円';
    }
  } else if (unitFormula == 'xbrli:pure') {
    str = '';
    if (lang == 'en') {
      str += '%';
    } else {
      str += '%';
    }
  } else if (unitFormula == 'iso4217:JPY/xbrli:shares') {
    str = '';
    if (lang == 'en') {
      str += 'JPY';
    } else {
      str += '円';
    }
  } else if (unitFormula == 'xbrli:shares') {
    str = '';
    if (lang == 'en') {
      str += '%';
    } else {
      str += '%';
    }
  }
  return str;
}

function getValue(val, unit, unitFormula, minusFormat) {
  var str = val;

  if (str == null || !(str.length > 0)) {
     return noDataStr;
  }

  if (str == 0) { 
    return getMinusFormatVal(str, minusFormat);
  }

  if (unitFormula == 'iso4217:JPY') {
    if (unit == '-3') {
      str = getIso4217JPYFormatVal(str, 3);
    } else if (unit == '-6') {
      str = getIso4217JPYFormatVal(str, 6);
    }
    //str = formatNumber(str);
  } else if (unitFormula == 'xbrli:pure') {
    str = (new Number(str) * 100).toFixed(1);
  } else if (unitFormula == 'iso4217:JPY/xbrli:shares') {
  } else if (unitFormula == 'xbrli:shares') {
  }

  str = formatNumber(str);
  str = getMinusFormatVal(str, minusFormat);

  return str;
}

function getIso4217JPYFormatVal(val, len) {
  var str=val;
  if (str.length > len) {
    str = str.substring(0, str.length-len);
    if (str == '-') {
      str = '-0';
    }
  }else {
    if ((str+'').match(/^-/)) {
      str = '-0';
    } else {
      str = '0';
    }
  }
  return str;
}

function getMinusFormatVal(val, minusFormat) {
  var str=val;
  if (minusFormat != undefined) {
    if ((str+'').match(/^-/)) {
      str = str.replace('-','');
      str = minusFormat.replace('${val}',str);
    }
  }
  return str;
}

function formatNumber(val) {

    var str=val;
    var num = new String(str).replace(/,/g/"");
    while(num != (num =num.replace(/^(-?\d+)(\d{3})/,"$1,$2")));
    return num;
 
}

function checkCval(cval) {
  if (cval == '') {
    return noDataStr;
  } else {
    return cval;
  }
}

function getNoValClassName(cval) {
  if (cval == noDataStr) {
    return ' xj_chart_no_value';
  } else {
    return '';
  }
}

function getTdLastClassName(check) {
  if (check) {
    return ' xj_chart_td_last';
  } else {
    return '';
  }
}

function getDataURL(company, chartType, number, lang) {
  var url = DATA_URL;
  url+= '?company=' + company;
  url+= '&chartType=' + chartType;
  url+= '&number=' + number;
  url+= '&lang=' + lang;
  url+= getCharacterSetParam();
  url+= '&output=json&callback=?';
  return url;
}

function getCharacterSetParam() {
  var val = '';
  var c = document.characterSet;
  if (c == null || !c) {
    c = document.charset;
  }
  if (!(c == null || !c)) {
    val = '&enc=' + c;
  }
  return val;
}

// 
// 経営成績
// 
getXJ_Table('xj_table1_9', 'AS80522', '1', '9', 'ja', '-6', null, false, false);
getXJ_Table('xj_table2_9', 'AS80522', '2', '9', 'ja', '-6', null, false, false);
getXJ_Table('xj_table3_9', 'AS80522', '3', '9', 'ja', '-6', null, false, false);
getXJ_Table('xj_table4_9', 'AS80522', '4', '9', 'ja', '-6', null, false, false);
getXJ_Table('xj_table7_9', 'AS80522', '7', '9', 'ja', null, null, false, false);
getXJ_Table_EOY('xj_table27_2', 'AS80522', '27', '2', 'ja', null, null, false, true);

// 
// 財政状況
// 
getXJ_Table('xj_table5_9', 'AS80522', '5', '9', 'ja', '-6', null, false, false);
getXJ_Table('xj_table6_9', 'AS80522', '6', '9', 'ja', '-6', null, false, false);
getXJ_Table('xj_table8_9', 'AS80522', '8', '9', 'ja', null, null, false, false);
getXJ_Table('xj_table9_9', 'AS80522', '9', '9', 'ja', null, null, false, false);

// 
// キャッシュ・フローの状況
// 
getXJ_Table('xj_table10_9', 'AS80522', '10', '9', 'ja', '-6', null, false, false);
getXJ_Table('xj_table11_9', 'AS80522', '11', '9', 'ja', '-6', null, false, false);
getXJ_Table('xj_table12_9', 'AS80522', '12', '9', 'ja', '-6', null, false, false);
getXJ_Table('xj_table13_9', 'AS80522', '13', '9', 'ja', '-6', null, false, false);

}(jQuery));